import React from "react";
import "../business-info/business-info.css";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import axios from "../../utils/fvAxios";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import "./address-info.css";
import apiinfo from "../../utils/base-uri.json";
import { useState } from "react";
import { Tooltip } from "@mui/material";


class AddressInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      countries: [],
      CountrySelectedForm: props?.data?.CountrySelectedForm,
      //   selectedCountry: props.data.CountrySelectedForm,
      CitesForm: props?.data?.CitesForm,
      AddressLine1Form: props?.data?.addressLine1Value,
      StateSelectedForm: props?.data?.StateSelectedForm,
      ZipCodeForm: props?.data?.ZipCodeForm,
      languageForm: props?.data?.languageForm,
      RegionsForm: props?.data?.RegionsForm,
      states: [],
      regions: [],
      languages: []
    };
  }
  componentDidMount() {
    axios.get(apiinfo.addressInfo.getCountries).then((res) => {
      const countries = res?.data?.data;
      this.setState({ countries: countries, regions: countries }, () => {
        // Assuming the value you need is in the first country
        if (countries?.length > 0) {
          this?.getCountryStates(countries[0]?.value);
        }
      });
    });
  }
  // componentDidMount() {
  //   axios.get(apiinfo.addressInfo.getCountries).then((res) => {
  //     this.setState({ countries: res.data.data });
  //     this.setState({ regions: res.data.data });
  //     this.getCountryStates(res?.data?.data[0]?.value);
  //   });

  // }

  async getCountryStates(e) {
    const canadaFlag = "&includeCanada=false";
    // await this.setState({ selectedCountry: e });
    await this?.setState({ CountrySelectedForm: e });
    await this?.setState({ StateSelectedForm: "" });
    if (this?.state?.CountrySelectedForm != "") {
      axios
        .get(
          apiinfo.addressInfo.getStateByRegion +
          "clientID=" +
          0 +
          "&country=" +
          this?.state?.CountrySelectedForm +
          canadaFlag
        )
        .then((response) => this?.setState({ states: response?.data?.data }));

      axios.get("Common/GetCountryLanguages?country=" + this?.state?.CountrySelectedForm)
        .then((res) => {
          this?.setState({ languages: res?.data?.data })
          this?.handleLanguage(res?.data?.data[0]?.key)
        })
    }
  }
  async handleAddress(e) {
    await this?.setState({ AddressLine1Form: e });
  }
  async handleStates(e) {
    await this?.setState({ StateSelectedForm: e });
  }
  async handleCites(e) {
    await this?.setState({ CitesForm: e });
    this?.props?.setAddressLine1ValueError("");
  }
  async handleZipCode(e) {
    await this?.setState({ ZipCodeForm: e });
  }
  async handleLanguage(e) {
    await this?.setState({ languageForm: e });
  }
  async handleRegions(e) {
    await this?.setState({ RegionsForm: e });
  }

  render() {
    return (
      <>
        <div className="first-verify__registerationContainer">
          <div className="first-verify__inputContainer">
            <div className="formControl-container">
              <span className="username-label">
                {this?.props?.languageContent?.addressInfo?.country}
                <span className="asterisk-red">*</span>
              </span>

              <select
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  height: 50,
                }}
                className="updated-select mt-1"
                error={this?.props?.countrySelectedFormErrorFlag}
                // defaultValue={this.props.data.CountrySelectedForm}
                value={this?.state?.CountrySelectedForm}
                onChange={(e) => this?.getCountryStates(e?.target?.value)}
              >
                {/* <option>--Select Country--</option> */}
                {this?.state?.countries?.map((country, index) => (
                  <option key={index} value={country?.value}>
                    {country?.value}
                  </option>
                ))}
              </select>
            </div>

            <div className="formControl-container">
              <span className="username-label">
                {this?.props?.languageContent?.addressInfo?.states}
                <span className="asterisk-red">*</span>
              </span>

              <select
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  height: 50,
                }}
                className="updated-select mt-1"
                // defaultValue={this.props.data.StateSelectedForm}
                value={this?.state?.StateSelectedForm}
                onChange={(e) => this?.handleStates(e?.target?.value)}
              >
                {/* <option>--Select States--</option> */}
                {this?.state?.states?.map((country, index) => (
                  <option key={index} value={country?.value}>
                    {country?.value}
                  </option>
                ))}
              </select>
            </div>
            <div className="formControl-container">
              <div>{this?.props?.TaxId}</div>
              <span className="username-label">
                {"City"}
                <span className="asterisk-red">*</span>
              </span>
              <TextField
                id="outlined-basic"
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  height: 50,
                }}
                placeholder={"City"}
                error={this?.props?.addressLine1ValueErrorFlag}
                defaultValue={this?.props?.data?.CitesForm}
                inputProps={{ className: "login-user" }}
                onChange={(e) => this?.handleCites(e?.target?.value)}
                variant="outlined"
              />
            </div>

            <div className="formControl-container">
              <div>{this.props.TaxId}</div>
              <span className="username-label">
                {this?.props?.languageContent?.addressInfo?.addressLine1}
                <span className="asterisk-red">*</span>
              </span>
              <Tooltip
                placement="left-start"
                title={
                  <div >
                    <h6>Street address, P.O.box, company name, c/o</h6>
                  </div>
                }
                arrow
              >
              <TextField
                id="outlined-basic"
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  height: 50,
                }}
                placeholder={
                  this?.props?.languageContent?.addressInfo?.addressLine1
                }
                defaultValue={this?.props?.data?.addressLine1Value}
                error={this?.props?.addressLine1ValueErrorFlag}
                inputProps={{ className: "login-user" }}
                onChange={(e) => this?.handleAddress(e?.target?.value)}
                variant="outlined"
              />
              </Tooltip>
            </div>
            <div className="formControl-container">
              <span className="username-label">
                {this?.props?.languageContent?.addressInfo?.zipCode}
                <span className="asterisk-red">*</span>
              </span>
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  height: 50,
                }}
                id="outlined-basic"
                placeholder={this?.props?.languageContent?.addressInfo?.zipCode}
                defaultValue={this?.props?.data?.ZipCodeForm}
                error={this?.props?.ZipCodeFormErrorFlag}
                inputProps={{ className: "login-user" }}
                onChange={(e) => this?.handleZipCode(e?.target?.value)}
                variant="outlined"
              />
            </div>
            <div className="formControl-container">
              <span className="username-label">
                {this?.props?.languageContent?.addressInfo?.selectLanguage}
                {/* <span className="asterisk-red">*</span> */}
              </span>
              <select
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },

                }}
                className="updated-select mt-1"
                id="demo-simple-select-4"
                // defaultValue={this.props.languageContent.addressInfo.selectLanguage}
                defaultValue={
                  this?.props?.data?.languageForm === ""
                    ? "selectLanguage"
                    : this?.props?.data?.languageForm
                }
                inputProps={{ className: "select-option" }}
                onChange={(e) => this?.handleLanguage(e?.target?.value)}
              >
                {this?.state?.languages?.map((r, index) => (
                  <option key={index} value={r?.key}>
                    {r?.value}
                  </option>
                ))}

                {/* <option value={"selectLanguage"}>--SelectLanguage--</option>
                <option value={"English"}>English</option>
                <option value={"Spanish"}>Spanish</option> */}

              </select>
            </div>
            <div className="formControl-container">
              <span className="username-label">
                {this?.props?.languageContent?.addressInfo?.vendorOperatingRegion}
                <span className="asterisk-red">*</span>
              </span>

              <select
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  height: 50,
                }}
                className="updated-select mt-1"
                // defaultValue={this.props.data.RegionsForm}
                value={this?.state?.RegionsForm}
                onChange={(e) => this?.handleRegions(e?.target?.value)}
              >
                <option>--Vendor Operating Region--</option>
                {this?.state?.regions?.map((country) => (
                  <option key={country?.key}>{country?.value}</option>
                ))}
              </select>
            </div>
            <div className="formControl-container">
              <Button
                variant="outlined"
                className="login-button-cancel-address"
                onClick={() =>
                  this?.props?.data?.setAddressInfoStates(
                    this?.state?.AddressLine1Form?.trim(),
                    this?.state?.CountrySelectedForm?.trim(),
                    this?.state?.StateSelectedForm?.trim(),
                    this?.state?.CitesForm?.trim(),
                    this?.state?.ZipCodeForm?.trim(),
                    this?.state?.languageForm?.trim(),
                    this?.state?.RegionsForm?.trim(),
                    "back"
                  )
                }
                sx={{
                  marginTop: 1,
                  fontWeight: 500,
                  textTransform: "capitalize",
                }}
              >
                {this?.props?.languageContent?.addressInfo?.back}
              </Button>
              <Button
                variant="contained"
                className="login-button-address"
                sx={{ textTransform: "capitalize" }}
                onClick={() =>
                  this?.props?.data?.setAddressInfoStates(
                    this?.state?.AddressLine1Form?.trim(),
                    this?.state?.CountrySelectedForm?.trim(),
                    this?.state?.StateSelectedForm?.trim(),
                    this?.state?.CitesForm?.trim(),
                    this?.state?.ZipCodeForm?.trim(),
                    this?.state?.languageForm?.trim(),
                    this?.state?.RegionsForm?.trim(),
                    "next"
                  )
                }
              >
                {this?.props?.languageContent?.addressInfo?.next}
              </Button>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default AddressInfo;